<template>
  <div id="setmall">
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <div>
        <div
          class="br-pagetitle d-flex justify-content-between align-items-center"
        >
          <div class="d-flex align-items-center">
            <i class="fa fa-sitemap"></i>
            <div class="mg-l-20 mg-b-0 d-flex align-items-center">
              <h4 class="mg-r-15">{{ $t("transfer.快递签收入库") }}</h4>
              <div class="mode-change">
                <a
                  href="javascript:;"
                  class="btn btn-icon mg-r-5 btn-info active"
                  data-trigger="hover"
                  data-toggle="tooltip-primary"
                  data-placement="bottom"
                  :data-original-title="$t('transfer.设置打印条形码尺寸')"
                  @click="openSize()"
                >
                  <div>
                    <i class="icon ion-gear-b" style="font-size: 24px"></i>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div class="tx-right"></div>
        </div>
        <div
          class="
            d-flex
            align-items-center
            justify-content-start
            pd-x-20 pd-sm-x-30
          "
        ></div>
      </div>
      <ul class="tabs">
        <li class="shadow">
          <a class="active" href="javascript:;">{{
            $t("transfer.快递签收")
          }}</a>
        </li>
        <li>
          <router-link to="/sign-check">{{
            $t("transfer.签收记录查询")
          }}</router-link>
        </li>
        <li>
          <router-link to="/sign-customer">{{
            $t("transfer.代客预报")
          }}</router-link>
        </li>
      </ul>
      <div>
        <div class="br-pagebody pd-x-20 pd-sm-x-30">
          <div class="card bd-gray-400 pd-30">
            <div class="form-group row mg-b-10">
              <label
                class="
                  col-md-2 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                  tx-white
                "
                >{{ $t("transfer.国内快递单号：") }}</label
              >
              <div class="col-md-6 col-sm-12">
                <input
                  id="focusTrackNumber"
                  @change="scanStorage('1')"
                  v-model.trim="trackNum"
                  type="text"
                  :placeholder="$t('transfer.国内快递单号')"
                  class="form-control tx-13 form-control-dark"
                />
                <span class="tx-danger" v-if="!trackNum">{{
                  $t("transfer.请填写快递单号")
                }}</span>
              </div>
            </div>
            <div class="form-group row mg-b-10 align-items-center">
              <label
                class="
                  col-md-2 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                  tx-white
                "
                >{{ $t("transfer.包裹重量(克)：") }}</label
              >
              <div class="col-md-4 col-sm-12">
                <!--@keyup.enter="$event.target.blur"-->
                <input
                  id="focusTrackWeight"
                  type="text"
                  v-model.trim="trackWeight"
                  @change="scanStorage('2')"
                  :placeholder="$t('transfer.包裹重量')"
                  class="form-control tx-13 form-control-dark"
                />
                <span
                  class="tx-danger"
                  v-if="!trackWeight || trackWeight <= 0"
                  >{{ $t("transfer.请填写快递单号") }}</span
                >
              </div>
              <div class="col-md-3 col-sm-12">
                <label class="ckbox mg-b-0 d-inline-block valign-middle">
                  <input type="checkbox" v-model="needVolume" />
                  <span>{{ $t("transfer.需要测量体积") }}</span>
                </label>
              </div>
            </div>
            <div class="form-group row mg-b-10" v-show="needVolume">
              <label
                class="
                  col-md-2 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                  tx-white
                "
                >{{ $t("transfer.包裹体积") }}(cm)：</label
              >
              <div class="col-md-2 col-sm-12">
                <input
                  id="focusTrackLong"
                  type="text"
                  @keyup.enter="scanStorageVolume('long')"
                  v-model.trim="trackLong"
                  :placeholder="$t('transfer.长')"
                  class="form-control tx-13 form-control-dark"
                />
              </div>
              <div class="col-md-2 col-sm-12">
                <input
                  id="focusTrackWidth"
                  type="text"
                  @keyup.enter="scanStorageVolume('width')"
                  v-model.trim="trackWidth"
                  :placeholder="$t('transfer.宽')"
                  class="form-control tx-13 form-control-dark"
                />
              </div>
              <div class="col-md-2 col-sm-12">
                <input
                  id="focusTrackHeight"
                  type="text"
                  @keyup.enter="scanStorageVolume('height')"
                  v-model.trim="trackHeight"
                  :placeholder="$t('transfer.高')"
                  class="form-control tx-13 form-control-dark"
                />
              </div>
              <div class="col-md-3 col-sm-12">
                <a
                  href="javascript:;"
                  class="btn btn-primary"
                  @click="scanStorageVolume('volume')"
                  >{{ $t("transfer.提交体积") }}</a
                >
              </div>
            </div>
            <div class="form-group row mg-t-50">
              <label
                class="
                  col-md-2 col-sm-12 col-form-label
                  form-control-sm
                  text-right
                  tx-white
                "
              ></label>
              <div class="col-md-6 col-sm-12">
                <div
                  class="alert alert-success alert-solid"
                  role="alert"
                  v-show="successScan"
                >
                  <div class="d-flex justify-content-start">
                    <i
                      class="
                        icon
                        ion-ios-checkmark
                        alert-icon
                        tx-32
                        mg-t-5 mg-xs-t-0
                      "
                    ></i>
                    <div>
                      <p>
                        <strong>{{ $t("transfer.签收成功") }}</strong>
                      </p>
                      <p>{{ trackNum2 }} {{ $t("transfer.签收成功") }}</p>
                    </div>
                  </div>
                </div>
                <div
                  class="alert alert-danger alert-solid"
                  role="alert"
                  v-show="failScan"
                >
                  <div class="d-flex justify-content-start">
                    <i class="icon ion-ios-close alert-icon tx-32"></i>
                    <div>
                      <p>
                        <strong>{{ $t("transfer.签收失败") }}</strong>
                      </p>
                      <p>{{ trackNum2 }} {{ $t("transfer.签收失败") }}</p>
                      <p>{{ $t("transfer.失败原因：") }}{{ failTxt }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <api-loading :show="loading"></api-loading>
    <Modal
      :modalId="'modalBarcodeSize'"
      :home="false"
      :size="'sm'"
      :autoH="true"
    >
      <template slot="header">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("transfer.设置打印标签尺寸") }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </template>
      <template slot="body">
        <div class="body-inner">
          <div class="form-group row mg-b-0">
            <label
              class="
                col-md-3 col-sm-12 col-form-label
                form-control-sm
                text-right
              "
            >
              {{ $t("transfer.规格(mm):") }}
            </label>
            <div class="col-md-4 col-sm-12">
              <input
                v-model="modalBarcodeSize.width"
                :placeholder="$t('transfer.宽(mm)')"
                type="text"
                class="form-control form-control-sm"
              />
            </div>
            <div class="col-md-4 col-sm-12">
              <input
                v-model="modalBarcodeSize.height"
                :placeholder="$t('transfer.高')"
                type="text"
                class="form-control form-control-sm"
              />
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div class="modal-footer d-block pd-y-15 pd-x-0">
          <div
            class="
              form-group
              row
              align-items-center
              justify-content-end
              pd-x-25
              mg-b-0
            "
          >
            <button
              type="button"
              class="
                mg-r-30
                btn btn-primary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              @click="saveBarcodeSize()"
            >
              {{ $t("transfer.保存") }}
            </button>
            <button
              type="button"
              class="
                btn btn-secondary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              data-dismiss="modal"
            >
              {{ $t("transfer.取消") }}
            </button>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from "@components/Modal";
import { getLodop } from "@/directive/LodopFuncs.js"; //分页

export default {
  components: {
    Modal,
  },
  data() {
    return {
      leftSideStatus: true, //左边栏状态
      loading: false,
      firstLoading: true,
      items: [],
      needVolume: false,
      trackNum: "",
      trackNum2: "",
      trackWeight: "",
      trackLong: "",
      trackWidth: "",
      trackHeight: "",
      failScan: false,
      successScan: false,
      failTxt: "",
      packageId: "",
      modalBarcodeSize: {
        width: "",
        height: "",
      },
    };
  },
  computed: {},
  watch: {
    needVolume() {
      localStorage.setItem("needVolume", this.needVolume ? 1 : 0);
    },
  },
  updated() {
    $('[data-toggle="tooltip-primary"]').tooltip({
      template:
        '<div class="tooltip tooltip-primary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
    });
  },
  methods: {
    openSize() {
      $("#modalBarcodeSize").modal("show");
      if (localStorage.getItem("saveBarcodeSizeInfo")) {
        this.modalBarcodeSize.width = JSON.parse(
          localStorage.getItem("saveBarcodeSizeInfo")
        ).width;
        this.modalBarcodeSize.height = JSON.parse(
          localStorage.getItem("saveBarcodeSizeInfo")
        ).height;
      }
    },
    saveBarcodeSize() {
      if (!this.modalBarcodeSize.width || !this.modalBarcodeSize.height) {
        ShowTip(this.$t("transfer.请填写完整的规格"), "danger");
        return;
      }
      $("#modalBarcodeSize").modal("hide");
      localStorage.setItem(
        "saveBarcodeSizeInfo",
        JSON.stringify(this.modalBarcodeSize)
      );
    },
    print(item) {
      let height = 0;
      let LODOP = getLodop(); //调用getLodop获取LODOP对象
      if (!LODOP) return;
      LODOP.PRINT_INIT("");
      if (
        this.modalBarcodeSize.width != "" &&
        this.modalBarcodeSize.height != ""
      ) {
        height = `${this.modalBarcodeSize.height * 3.8 * 0.3}`;
        LODOP.SET_PRINT_PAGESIZE(
          0,
          `${this.modalBarcodeSize.width * 10}`,
          `${this.modalBarcodeSize.height * 10}`,
          ""
        );
        LODOP.ADD_PRINT_BARCODE(
          `${this.modalBarcodeSize.height * 3.8 * 0.05}`,
          `${this.modalBarcodeSize.width * 3.8 * 0.3}`,
          `${this.modalBarcodeSize.width * 3.8 * 0.4}`,
          `${this.modalBarcodeSize.height * 3.8 * 0.4}`,
          "QRCode",
          item.packageId
        );
        LODOP.ADD_PRINT_BARCODE(
          `${this.modalBarcodeSize.height * 3.8 * 0.45}`,
          `${this.modalBarcodeSize.width * 3.8 * 0.1}`,
          `${this.modalBarcodeSize.width * 3.8 * 0.8}`,
          `${this.modalBarcodeSize.height * 3.8 * 0.2}`,
          "Code93",
          item.packageId
        );
        LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
      } else if (localStorage.getItem("saveBarcodeSizeInfo")) {
        height = `${
          JSON.parse(localStorage.getItem("saveBarcodeSizeInfo")).height *
          3.8 *
          0.3
        }`;
        LODOP.SET_PRINT_PAGESIZE(
          0,
          `${
            JSON.parse(localStorage.getItem("saveBarcodeSizeInfo")).width * 10
          }`,
          `${
            JSON.parse(localStorage.getItem("saveBarcodeSizeInfo")).height * 10
          }`,
          ""
        );
        LODOP.ADD_PRINT_BARCODE(
          `${
            JSON.parse(localStorage.getItem("saveBarcodeSizeInfo")).height *
            3.8 *
            0.05
          }`,
          `${
            JSON.parse(localStorage.getItem("saveBarcodeSizeInfo")).width *
            3.8 *
            0.3
          }`,
          `${
            JSON.parse(localStorage.getItem("saveBarcodeSizeInfo")).width *
            3.8 *
            0.4
          }`,
          `${
            JSON.parse(localStorage.getItem("saveBarcodeSizeInfo")).height *
            3.8 *
            0.4
          }`,
          "QRCode",
          item.packageId
        );
        LODOP.ADD_PRINT_BARCODE(
          `${
            JSON.parse(localStorage.getItem("saveBarcodeSizeInfo")).height *
            3.8 *
            0.45
          }`,
          `${
            JSON.parse(localStorage.getItem("saveBarcodeSizeInfo")).width *
            3.8 *
            0.1
          }`,
          `${
            JSON.parse(localStorage.getItem("saveBarcodeSizeInfo")).width *
            3.8 *
            0.8
          }`,
          `${
            JSON.parse(localStorage.getItem("saveBarcodeSizeInfo")).height *
            3.8 *
            0.2
          }`,
          "Code93",
          item.packageId
        );
        LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
      } else {
        height = 100 * 3.8 * 0.3;
        LODOP.SET_PRINT_PAGESIZE(0, "100mm", "50mm", "");
        LODOP.ADD_PRINT_BARCODE(
          100 * 3.8 * 0.05,
          100 * 3.8 * 0.3,
          100 * 3.8 * 0.4,
          100 * 3.8 * 0.4,
          "QRCode",
          item.packageId
        );
        LODOP.ADD_PRINT_BARCODE(
          100 * 3.8 * 0.45,
          100 * 3.8 * 0.1,
          100 * 3.8 * 0.8,
          100 * 3.8 * 0.2,
          "Code93",
          item.packageId
        );
      }
      LODOP.SET_PRINT_STYLEA(0, "ShowBarText", 0); //设置是否显示下方的文字
      if (height < 30) {
        LODOP.ADD_PRINT_TEXT(
          "62%",
          "0%",
          "100%",
          18,
          `内部ID：${item.packageId}`
        );
        LODOP.SET_PRINT_STYLEA(0, "FontName", "微软雅黑");
        LODOP.SET_PRINT_STYLEA(0, "FontSize", 8);
        LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
        //				LODOP.ADD_PRINT_TEXT("80%","0%","100%",18,`物流单号：${item.trackNumber}`);
        //				LODOP.SET_PRINT_STYLEA(0,"FontName","微软雅黑");
        //				LODOP.SET_PRINT_STYLEA(0,"FontSize",8);
        //				LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
      } else if (height < 60) {
        LODOP.ADD_PRINT_TEXT(
          "68%",
          "0%",
          "100%",
          22,
          `内部ID：${item.packageId}`
        );
        LODOP.SET_PRINT_STYLEA(0, "FontName", "微软雅黑");
        LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
        LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
        LODOP.ADD_PRINT_TEXT(
          "78%",
          "0%",
          "100%",
          22,
          `物流单号：${this.trackNum}`
        );
        LODOP.SET_PRINT_STYLEA(0, "FontName", "微软雅黑");
        LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
        LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
        if (item.distributorName != "") {
          LODOP.ADD_PRINT_TEXT(
            "88%",
            "0%",
            "100%",
            18,
            `客户名称：${item.distributorName}`
          );
          LODOP.SET_PRINT_STYLEA(0, "FontName", "微软雅黑");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 10);
          LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
        }
      } else if (height < 100) {
        LODOP.ADD_PRINT_TEXT(
          "70%",
          "0%",
          "100%",
          25,
          `内部ID：${item.packageId}`
        );
        LODOP.SET_PRINT_STYLEA(0, "FontName", "微软雅黑");
        LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
        LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
        LODOP.ADD_PRINT_TEXT(
          "78%",
          "0%",
          "100%",
          25,
          `物流单号：${this.trackNum}`
        );
        LODOP.SET_PRINT_STYLEA(0, "FontName", "微软雅黑");
        LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
        LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
        if (item.distributorName != "") {
          LODOP.ADD_PRINT_TEXT(
            "86%",
            "0%",
            "100%",
            18,
            `客户名称：${item.distributorName}`
          );
          LODOP.SET_PRINT_STYLEA(0, "FontName", "微软雅黑");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 12);
          LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
        }
      } else {
        LODOP.ADD_PRINT_TEXT(
          "70%",
          "0%",
          "100%",
          30,
          `内部ID：${item.packageId}`
        );
        LODOP.SET_PRINT_STYLEA(0, "FontName", "微软雅黑");
        LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
        LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
        LODOP.ADD_PRINT_TEXT(
          "78%",
          "0%",
          "100%",
          30,
          `物流单号：${this.trackNum}`
        );
        LODOP.SET_PRINT_STYLEA(0, "FontName", "微软雅黑");
        LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
        LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
        if (item.distributorName != "") {
          LODOP.ADD_PRINT_TEXT(
            "86%",
            "0%",
            "100%",
            18,
            `客户名称：${item.distributorName}`
          );
          LODOP.SET_PRINT_STYLEA(0, "FontName", "微软雅黑");
          LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
          LODOP.SET_PRINT_STYLEA(0, "Alignment", 2);
        }
      }

      //	  	LODOP.SET_PRINT_MODE("PRINT_PAGE_PERCENT","Auto-Width");
      //	  	LODOP.PREVIEW();
      //				LODOP.PRINT_DESIGN();
      LODOP.PRINT();
    },
    playSound(type) {
      let src = type == "success" ? "audio/save.mp3" : "audio/error.mp3";
      var borswer = window.navigator.userAgent.toLowerCase();
      if (borswer.indexOf("ie") >= 0) {
        //IE内核浏览器
        var strEmbed =
          '<embed name="embedPlay" src="' +
          src +
          '" autostart="true" hidden="true" loop="false"></embed>';
        if ($("body").find("embed").length <= 0) $("body").append(strEmbed);
        var embed = document.embedPlay;

        //浏览器不支持 audion，则使用 embed 播放
        embed.volume = 100;
        //embed.play();这个不需要
      } else {
        //非IE内核浏览器
        var strAudio = '<audio id="audioPlay" src="' + src + '" hidden="true">';
        if ($("body").find("audio").length <= 0) {
          $("body").append(strAudio);
          var audio = document.getElementById("audioPlay");
        } else {
          $("body").find("audio").remove();
          $("body").append(strAudio);
          var audio = document.getElementById("audioPlay");
        }
        //浏览器支持 audion
        audio.play();
      }
    },
    scanStorageVolume(type) {
      switch (type) {
        case "long":
          if (!this.trackLong) {
            ShowTip(this.$t("transfer.请填写包裹体积的长度"), "danger");
            return;
          }
          document.getElementById("focusTrackWidth").focus();
          break;
        case "width":
          if (!this.trackWidth) {
            ShowTip(this.$t("transfer.请填写包裹体积的宽度"), "danger");
            return;
          }
          document.getElementById("focusTrackHeight").focus();
          break;
        case "height":
          if (!this.trackHeight) {
            ShowTip(this.$t("transfer.请填写包裹体积的高度"), "danger");
            return;
          } else {
            if (!this.trackLong || !this.trackWidth || !this.trackHeight) {
              ShowTip(
                this.$t("transfer.包裹体积的长宽高必须填写完整"),
                "danger"
              );
              return;
            } else {
              this.scanStorageVolumeFn(type);
            }
          }
          break;
        case "volume":
          if (!this.trackLong || !this.trackWidth || !this.trackHeight) {
            ShowTip(this.$t("transfer.包裹体积的长宽高必须填写完整"), "danger");
            return;
          } else {
            this.scanStorageVolumeFn(type);
          }
          break;
      }
    },
    scanStorageVolumeFn(type) {
      if (!this.trackWeight || this.trackWeight <= 0) {
        ShowTip(this.$t("transfer.请填写包裹重量"), "danger");
        return;
      }
      this.loading = true;
      $.api_call(
        "api.DistributorPackage.saveWeight",
        {
          packageId: this.packageId,
          weight: this.trackWeight,
          long: this.trackLong,
          width: this.trackWidth,
          height: this.trackHeight,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(this.$t("transfer.操作成功"), "success");
            setTimeout(() => {
              if (this.needVolume) {
                if (type) {
                  this.trackNum = "";
                  this.trackWeight = "";
                  this.trackLong = "";
                  this.trackWidth = "";
                  this.trackHeight = "";
                  document.getElementById("focusTrackNumber").focus();
                } else {
                  document.getElementById("focusTrackLong").focus();
                }
              } else {
                this.trackNum = "";
                this.trackWeight = "";
                document.getElementById("focusTrackNumber").focus();
              }
            }, 100);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    scanStorageWeight(type) {
      if (!this.trackWeight || this.trackWeight <= 0) {
        ShowTip(this.$t("transfer.请填写包裹重量"), "danger");
        return;
      }
      this.loading = true;
      //		$.api_call('api.DistributorPackage.saveWeight',{
      //			packageId: this.packageId,
      //				weight: this.trackWeight,
      //				long: this.trackLong,
      //				width: this.trackWidth,
      //				height: this.trackHeight,
      //		} , r => {
      //	      this.loading = false;
      //	      if (r.ErrorCode == "9999") {
      //	      	ShowTip("this.$t("transfer.操作成功")","success");
      //			    setTimeout(()=>{
      //			    	if(this.needVolume){
      //			    		if(type){
      //			    			this.trackNum = "";
      //			    			this.trackWeight = "";
      //			    			this.trackLong = "";
      //			    			this.trackWidth = "";
      //			    			this.trackHeight = "";
      //			    			document.getElementById("focusTrackNumber").focus();
      //			    		}else{
      //			    			document.getElementById("focusTrackLong").focus();
      //			    		}
      //
      //			    	}else{
      //			    		this.trackNum = "";
      //			    		this.trackWeight = "";
      //			    		document.getElementById("focusTrackNumber").focus();
      //			    	}
      //			    },100)
      //	      }else{
      //	        if (r.ErrorCode == "1002") {
      //          userFailure(this);
      //        } else {
      //        	ShowTip(r.Message,"danger");
      //        }
      //    	}
      //	    });
    },
    scanStorage(type) {
      if (type == "1") {
        if (!this.trackNum) {
          ShowTip(this.$t("transfer.请扫描物流单号"), "danger");
          document.getElementById("focusTrackNumber").focus();
          return;
        } else {
          if (!this.trackWeight || this.trackWeight <= 0) {
            setTimeout(() => {
              document.getElementById("focusTrackWeight").focus();
            }, 100);
            return;
          }
        }
      } else {
        if (!this.trackWeight || this.trackWeight <= 0) {
          ShowTip(this.$t("transfer.请填写包裹重量"), "danger");
          document.getElementById("focusTrackWeight").focus();
          return;
        } else {
          if (!this.trackNum) {
            setTimeout(() => {
              document.getElementById("focusTrackNumber").focus();
            }, 100);
            return;
          }
        }
      }

      this.trackNum2 = this.trackNum;
      this.loading = true;
      this.packageId = "";
      $.api_call(
        "api.DistributorPackage.scanStorage",
        {
          trackNumber: this.trackNum,
          weight: this.trackWeight,
          long: this.trackLong,
          width: this.trackWidth,
          height: this.trackHeight,
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            this.playSound("success");
            this.successScan = true;
            this.failScan = false;
            this.packageId = r.Data.Results.packageId;

            setTimeout(() => {
              if (this.needVolume) {
                document.getElementById("focusTrackLong").focus();
              } else {
                this.trackNum = "";
                this.trackWeight = "";
                document.getElementById("focusTrackNumber").focus();
              }
            }, 100);
            this.print(r.Data.Results);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              this.playSound("fail");
              this.failScan = true;
              this.successScan = false;
              this.failTxt = r.Message;
            }
          }
        }
      );
    },
  },
  mounted() {
    if (
      this.modalBarcodeSize.width != "" &&
      this.modalBarcodeSize.width != ""
    ) {
    } else if (localStorage.getItem("saveBarcodeSizeInfo")) {
    } else {
      $("#modalBarcodeSize").modal("show");
    }
    document.getElementById("focusTrackNumber").focus();

    this.needVolume = localStorage.getItem("needVolume") == 1 ? true : false;
  },
};
</script>

<style lang="less" scoped>
.br-pagetitle .fa {
  font-size: 60px;
  line-height: 70px;
  color: #343a40;
}
.br-pagetitle i.fa {
  color: #17a2b8;
  font-size: 70px;
}
.show-white-style .br-pagetitle i.fa {
  color: #343a40;
}
.white-body .mode-change a .icon {
  color: #17a2b8;
}
.white-body .mode-change a.active .icon,
.white-body .mode-change a:hover .icon {
  color: #fff;
}
.nav.nav-tabs {
  .nav-item {
    background-color: #fff;
    .nav-link {
      border-bottom-color: #ddd;
    }
    .nav-link:active,
    .nav-link.active {
      border-bottom: 1px solid transparent;
      color: inherit;
      background-color: #fff;
    }
    .nav-link:focus {
      color: #868ba1;
    }
    .nav-link:hover {
      background-color: #f0f0f0;
      color: #868ba1;
    }
    .nav-link.active:hover {
      background-color: #fff;
    }
  }
}
.tab-content {
  border: 1px #ddd solid;
  border-top: none;
  padding: 0 15px;
  .tab-container.active {
    display: block;
  }
  .tab-container {
    display: none;
  }
}

.modal-content {
  .sku-list {
    h3 {
      margin-bottom: 5px;
      height: 26px;
      line-height: 26px;
      font-size: 14px;
    }
  }
  tbody {
    font-size: 12px;
  }
  .pro-info {
    display: flex;
    .img-wrap {
      margin-right: 5px;
      max-width: 60px;
      max-height: 60px;
      min-width: 60px;
      min-height: 60px;
      border: 1px #ddd solid;
      background-color: #fff;
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
    }
    .right {
      display: flex;
      flex-flow: column;
      justify-content: space-between;
      max-width: 200px;
      min-width: 200px;
      line-height: 20px;
      .pro-attr {
        display: flex;
        justify-content: space-between;
      }
    }
  }
  .table-wrap {
    margin-bottom: 15px;
  }
  .new-return-bottom {
    border-top: 1px #ddd solid;
    padding: 15px 15px 0;
  }
  textarea {
    resize: none;
  }
}
.info-wrap {
  padding-top: 15px;
  border-top: 1px solid #ddd;
}
.input-wrap {
  margin: 0 -15px;
  padding-top: 15px;
  border-top: 1px solid #ddd;
}
input[type="text"]:focus {
  box-shadow: 0 0 4px #55a6f8;
  background-color: #c4e0fd;
}
.br-pagetitle .fa {
  font-size: 60px;
  line-height: 70px;
  color: #343a40;
}
.form-control-dark:active,
.form-control-dark:focus {
  color: #343a40;
}
.show-white-style .form-control-dark:active,
.show-white-style .form-control-dark:focus {
  color: #343a40;
}
.mode-change .btn-info,
.mode-change .btn-info.active {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}
.mode-change .btn-info i,
.mode-change .btn-info.active i {
  color: #fff;
}
</style>

